import { render } from "./ArticleJson.vue?vue&type=template&id=26c81390"
import script from "./ArticleJson.vue?vue&type=script&lang=js"
export * from "./ArticleJson.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__